/**
 * Official UTMify tracking scripts.
 * Loads the UTM parameter tracker plus the pixel tracker.
 */

const UTMIFY_SCRIPT_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'
const UTMIFY_PIXEL_SRC = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js'
const UTMIFY_PIXEL_ID = ''

export function loadUtmify(): void {
  if (typeof document === 'undefined') return

  // UTM parameter tracker
  if (!document.querySelector(`script[src="${UTMIFY_SCRIPT_SRC}"]`)) {
    const utmScript = document.createElement('script')
    utmScript.src = UTMIFY_SCRIPT_SRC
    utmScript.async = true
    utmScript.defer = true
    utmScript.setAttribute('data-utmify-prevent-xcod-sck', '')
    utmScript.setAttribute('data-utmify-prevent-subids', '')
    document.head.appendChild(utmScript)
  }

  // UTMify pixel
  if (UTMIFY_PIXEL_ID && !document.querySelector(`script[src="${UTMIFY_PIXEL_SRC}"]`)) {
    const win = window as unknown as Record<string, unknown>
    win.pixelId = UTMIFY_PIXEL_ID
    const pixelScript = document.createElement('script')
    pixelScript.src = UTMIFY_PIXEL_SRC
    pixelScript.async = true
    pixelScript.defer = true
    document.head.appendChild(pixelScript)
  }
}
